import React, {useState} from "react";
import _ from "lodash";
import RenderFields from "../../../common/ui/render-fields";
import {
    BULK_INSTAGRAM_POST_FIELDS,
} from "../../constants/shopify.constant";
import {applyBulkPostSchedule} from "../../utils/post-util";
import {batchSaveProductsList} from "../../services/shopify-product-data-service";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";

const defaultSettings: any = {
    postFrequency: 'every-day-same-time',
    postDate: (new Date()).toISOString().slice(0, 10),
    postTime: '7 AM',
}

const BulkSchedulePost = ({productsList, refreshProductList}) => {
    const [showModal, setShowModal] = useState(false);
    const [settings, setSettings] = useState(defaultSettings);
    const [saveInProgress, setSaveInProgress] = useState(false);

    const handleConfirmAction = async () => {
        setSaveInProgress(true);
        await batchSaveProductsList(productsList);
        setSaveInProgress(false);
        refreshProductList();
        setShowModal(false);
    }

    const handleSettingsChanges = (event) => {
        const {name, value, type} = event.target;
        const existingSettings = {...settings};

        if (type === 'checkbox') {
            existingSettings[name] = !existingSettings[name];
        } else if (type === 'number') {
            existingSettings[name] = _.parseInt(value);
        } else {
            existingSettings[name] = value;
        }

        // console.log({existingSettings})

        preparePostScheduleDetail(existingSettings);
        setSettings(existingSettings);
    }

    const preparePostScheduleDetail = (existingSettings) => {

        if (existingSettings.postFrequency && existingSettings.postDate && existingSettings.postTime) {
            applyBulkPostSchedule(existingSettings, productsList);
        }

    }

    return (
        <>
            <button
                className="button-green px-3 py-2"
                onClick={() => setShowModal(true)}>
                Bulk Post Schedule
            </button>

            {showModal ? (
                <>
                    <div
                        className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-x-0 top-0 z-50 outline-none focus:outline-none">
                        <div className="relative w-1/2 my-6 mx-auto max-w-3xl">
                            {/*content*/}
                            <div
                                className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                                {/*header*/}
                                <div
                                    className="flex items-start justify-between p-5 border-b border-solid rounded-t">
                                    <h3 className="text-lg font-semibold">
                                        Bulk Post Schedule
                                    </h3>
                                    <button
                                        className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                                        onClick={() => setShowModal(false)}>
                                            <span
                                                className="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                                              ×</span>
                                    </button>
                                </div>
                                {/*body*/}
                                <div className="relative p-4 flex-auto">
                                    <div className="leading-relaxed">
                                        <div className="flex flex-wrap justify-start">
                                            <RenderFields
                                                parentForm={settings}
                                                handleDetailChanges={handleSettingsChanges}
                                                fieldList={BULK_INSTAGRAM_POST_FIELDS}
                                                enableEdit={true}
                                                fieldClassName={'w-1/3'}/>
                                        </div>
                                    </div>
                                </div>
                                {/*footer*/}
                                <div
                                    className="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
                                    <button
                                        className="text-gray-500 font-bold border border-gray-500 h-10 rounded px-4 outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                        type="button"
                                        onClick={() => setShowModal(false)}>
                                        Cancel
                                    </button>
                                    <button
                                        className="ml-2 bg-green-500 text-white active:bg-green-600 h-10 rounded px-4 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                        type="button"
                                        onClick={handleConfirmAction}>
                                        Confirm Schedule
                                    </button>
                                    <div className="ml-4 -mt-1">
                                        <ShowProgressSpinner dataFetchInProgress={saveInProgress}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                </>
            ) : null}
        </>
    );
}

export default BulkSchedulePost
